import { ApolloError, useQuery } from '@apollo/client'
import { GetCountriesWithBranchOfficeVisibleFlagQuery, GetCountriesWithBranchOfficeVisibleFlagQueryVariables } from '../../../types'
import { GET_COUNTRIES_WITH_BRANCH_OFFICE_VISIBLE_FLAG } from '../Queries'

export default function (): {
  data: GetCountriesWithBranchOfficeVisibleFlagQuery | undefined
  error: ApolloError | undefined
  loading: boolean
} {
  const { data, error, loading } = useQuery<
    GetCountriesWithBranchOfficeVisibleFlagQuery,
    GetCountriesWithBranchOfficeVisibleFlagQueryVariables
  >(GET_COUNTRIES_WITH_BRANCH_OFFICE_VISIBLE_FLAG, {
    fetchPolicy: 'cache-first',
  })
  return { data, error, loading }
}
